// ReservationTypeSelector.jsx - Bireysel/Grup seçimi ve kişi sayısı
import React from 'react';

const ReservationTypeSelector = ({ 
  reservationType, 
  onChangeType, 
  numberOfPeople, 
  onChangeNumberOfPeople 
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold text-blue-100">
        Rezervasyon Tipi
      </h3>

      {/* Tip Seçimi */}
      <div className="grid grid-cols-2 gap-4">
        {/* Bireysel */}
        <div
          onClick={() => onChangeType('individual')}
          className={`
            p-5 rounded-lg border-2 cursor-pointer transition-all duration-200
            ${reservationType === 'individual'
              ? 'border-blue-500 bg-blue-900/30 shadow-lg shadow-blue-500/20'
              : 'border-gray-700 bg-gray-800/50 hover:border-blue-400'
            }
          `}
        >
          <div className="flex items-start justify-between mb-3">
            <div>
              <h4 className="text-lg font-bold text-blue-100">Bireysel</h4>
              <p className="text-sm text-gray-300 mt-1">1 Kişi</p>
            </div>
            {reservationType === 'individual' && (
              <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>

          <div className="flex items-baseline">
            <span className="text-3xl font-bold text-blue-300">30</span>
            <span className="text-sm text-gray-400 ml-1">TL/saat</span>
          </div>

          <div className="mt-3 flex items-center text-xs text-gray-400">
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            Tek kişilik kullanım
          </div>
        </div>

        {/* Grup */}
        <div
          onClick={() => onChangeType('group')}
          className={`
            p-5 rounded-lg border-2 cursor-pointer transition-all duration-200
            ${reservationType === 'group'
              ? 'border-blue-500 bg-blue-900/30 shadow-lg shadow-blue-500/20'
              : 'border-gray-700 bg-gray-800/50 hover:border-blue-400'
            }
          `}
        >
          <div className="flex items-start justify-between mb-3">
            <div>
              <h4 className="text-lg font-bold text-blue-100">Grup</h4>
              <p className="text-sm text-gray-300 mt-1">2-8 Kişi</p>
            </div>
            {reservationType === 'group' && (
              <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>

          <div className="flex items-baseline">
            <span className="text-3xl font-bold text-blue-300">50</span>
            <span className="text-sm text-gray-400 ml-1">TL/saat</span>
          </div>

          <div className="mt-3 flex items-center text-xs text-gray-400">
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            Kişi sayısından bağımsız
          </div>
        </div>
      </div>

      {/* Kişi Sayısı (Grup ise) */}
      {reservationType === 'group' && (
        <div className="p-4 bg-gray-800/50 rounded-lg border border-gray-700">
          <label className="block text-sm font-semibold text-blue-200 mb-2">
            Kişi Sayısı
          </label>
          <input
            type="number"
            min="2"
            max="8"
            value={numberOfPeople}
            onChange={(e) => onChangeNumberOfPeople(parseInt(e.target.value) || 2)}
            className="w-full px-4 py-2 bg-gray-900/50 border border-gray-600 rounded-lg text-white focus:outline-none focus:border-blue-500"
          />
          <p className="text-xs text-gray-300 mt-2">
            Grup rezervasyonu için 2-8 kişi arasında olmalıdır
          </p>
        </div>
      )}

      {/* Kapasite Uyarısı */}
      <div className="p-3 bg-yellow-900/20 border border-yellow-700/50 rounded-lg">
        <div className="flex items-start">
          <svg className="w-5 h-5 text-yellow-500 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <div className="text-xs text-yellow-200">
            <strong>Önemli:</strong> Her odanın maksimum kapasitesi 8 kişidir. 
            Belirtilen kişi sayısını aşmamanız gerekmektedir.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReservationTypeSelector;
